<template>
  <div class="search-list">
    <div class="loading" v-show="loading && searchText">
      <i class="el-icon-loading"></i>
      <div class="search-for">{{ searchingText }}</div>
    </div>
    <template v-if="searchText">
      <div v-show="!loading && list.length === 0" class="no-account">
        {{ noText }}
      </div>
      <template v-if="!loading">
        <search-item
          @click.native="itemClick(item)"
          class="item"
          :model="item"
          v-for="item in list"
          :key="item.id"
          :type="item.type"
        ></search-item>
      </template>
    </template>
    <template v-else>
      <el-popover
        placement="bottom"
        width="400"
        height="500"
        v-model="nearShow"
        v-if="type === 3"
        trigger="click"
      >
        <div class="search-list near">
          <search-item
            @click.native="itemClick(item)"
            class="item"
            :model="item"
            v-for="item in nearList"
            :key="item.id"
            :type="item.type"
          ></search-item>
        </div>
        <div slot="reference" class="near-location item">
          <div class="image-container"></div>
          <div class="right-container">Near Current Location</div>
        </div>
      </el-popover>
      <search-item
        @click.native="itemClick(item)"
        class="item"
        :model="item"
        v-for="item in historyList"
        :key="item.id"
        :type="item.type"
      ></search-item>
    </template>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";

.search-list {
  &.near {
    overflow: auto;
    height: 300px;
    padding: 10px 0;
  }

  .item {
    padding: 0 20px;
  }

  .loading {
    padding: 0 20px;
    color: @font-color-gray;
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      font-size: 20px;
    }

    .search-for {
      font-size: 14px;
      flex: 1;
      text-align: left;
      margin-left: 10px;
    }
  }

  .no-account {
    padding: 0 20px;
    color: @font-color-gray;
    font-size: 14px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .near-location {
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;

    &:hover,
    &:active {
      background: rgba(0, 0, 0, 0.1);
    }

    .image-container {
      height: 48px;
      width: 48px;
      border-radius: 50%;
      /*border: 1px solid #cccccc;*/
      background-image: url("../../../public/images/repost/icon_place_nearly@3x.png");
      background-size: cover;
    }

    .right-container {
      flex: 1;
      align-items: center;
      padding: 0 15px;
      color: @theme-color;
    }
  }
}
</style>

<script>
import SearchItem from "./SearchItem";
import {
  searchTop,
  searchTag,
  searchPeople,
  searchLocation,
  searchNearLocation,
} from "../../service/instagram";
import { showErrorMsg } from "../../utils/errors";
import { REPOST_HISTORY } from "../../store/mutation-types";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "RepostSearchListComponent",
  components: { SearchItem },
  props: {
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      list: [],
      searchText: "",
      nearShow: false,
      nearLoading: false,
      nearList: [],
      cancel: null,
      loading: false, // 是否数据在加载中
    };
  },
  computed: {
    ...mapGetters({ history: REPOST_HISTORY }),
    /**
     * 根据当前类型获取历史记录
     */
    historyList() {
      return this.history.filter((h) => h.searchTypeId === this.type);
    },
    searchingText() {
      return `Searching for "${this.searchText}"`;
    },
    noText() {
      if (this.type === 0 || this.type === 1) {
        return "No accounts found";
      } else if (this.type === 2) {
        return "No hashtags found";
      } else if (this.type === 3) {
        return "No locations found";
      }
    },
  },
  methods: {
    /**
     * 文本输入项发生变化由外部出发
     * @param q 查询的条件
     */
    async change(q) {
      if (this.cancel) {
        this.cancel();
        this.cancel = null;
      }
      this.refreshList(q);
    },
    async refreshList(q) {
      if (q === this.searchText || !q) {
        return;
      }
      this.searchText = q;
      let CancelToken = axios.CancelToken;
      const cancelToken = new CancelToken((c) => {
        this.cancel = c;
      });
      this.loading = true;
      try {
        if (this.type === 0) {
          this.list = await searchTop({ q, cancelToken });
        } else if (this.type === 1) {
          this.list = await searchPeople({ q, cancelToken });
        } else if (this.type === 2) {
          this.list = await searchTag({ q, cancelToken });
        } else if (this.type === 3) {
          this.list = await searchLocation({ q, cancelToken });
        }
        this.cancel = null;
        this.loading = false;
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * 清空查询结果
     */
    clear() {
      this.searchText = "";
    },
    /**
     * 点击选项回调
     * @param item 选中项
     */
    itemClick(item) {
      this.nearShow = false;
      this.$emit("itemClick", item);
    },
  },
  created() {
    if (this.type === 3) {
      // 获取附近信息
      searchNearLocation()
        .then((list) => {
          this.nearLoading = true;
          this.nearList = list;
        })
        .catch((e) => showErrorMsg(e))
        .finally(() => {
          this.nearLoading = false;
        });
    }
  },
};
</script>
